import { render, staticRenderFns } from "./dbs__list.vue?vue&type=template&id=7ef090f2"
import script from "./dbs__list.vue?vue&type=script&lang=js"
export * from "./dbs__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports